import React from 'react';
import { useDebouncedCallback } from 'use-debounce';

const SearchFilter = (props) => {

    

    const debounce = useDebouncedCallback((value) => {
        props.setSearchTerm(value);
    }, 500);

    return (
        <div className="search-component">
            <div className="search-icon">
                <label htmlFor="catalog-search-input">Search</label>
                <input type="search"
                    placeholder="Search tooling solutions catalog…"
                    value={props.searchTerm}
                    onChange={(e) => {
                        props.setSearchTerm(e.target.value)
                        debounce(e.target.value)
                    }}
                    id="catalog-search-input"
                    name="catalog-search-input"
                    aria-label="Search through site content"></input>
            </div>
        </div>
    )
}

export default SearchFilter;